import React, { useCallback, useState } from "react";
import {
  IconButton,
  LayerContextProvider,
  layers,
  List,
  ListItem,
  ListSeparator,
  Menu,
  TreeDotsIcon,
} from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import i18n from "~/i18n";

const RecurringSubtaskPanel = ({ onEdit, onDelete, index }) => {
  const [open, setOpen] = useState(false);
  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  const onDeleteCallback = useCallback(() => {
    onDelete(index);
    setOpen(false);
  }, [index, onDelete]);
  const onEditCallback = useCallback(() => {
    onEdit(index);
    setOpen(false);
  }, [index, onEdit]);

  return (
    <LayerContextProvider value={{ zIndex: layers.skyscraper }}>
      <Menu
        target={
          <IconButton
            className={classnames({ open: open }, "c-simple-menu__trigger tw-h-8 tw-w-8")}
            variant="text gray"
            active={open}
          >
            <TreeDotsIcon />
          </IconButton>
        }
        onOpen={onOpen}
        onClose={onClose}
        open={open}
      >
        <List className="tw-py-2">
          <ListItem onClick={onEditCallback}>{i18n.t("Edit")}</ListItem>
          <ListSeparator />
          <ListItem onClick={onDeleteCallback}>{i18n.t("Delete")}</ListItem>
        </List>
      </Menu>
    </LayerContextProvider>
  );
};

RecurringSubtaskPanel.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  index: PropTypes.number,
};

export default RecurringSubtaskPanel;
